const toUpper = (str) => {
    if (str != undefined && str != null){
      return str.toString().toUpperCase()
    } else {
      return null
    }
}

export default toUpper;